<template>
    <div class="sharePage">
<!--        <a href="https://appgallery.huawei.com/app/C102675979" class="sharebarimg">-->
<!--            <img src="../../images/shareBar-top.png" alt="">-->
<!--        </a>-->
        <div class="topicInfo">
            <div class="top" v-if="pageType==='topic'">
                <div v-if="pageInfo.logo.url" class="thumb"><img :src="pageInfo.logo.url" alt=""></div>
                <span>{{pageType==='topic'?'#':''}}{{pageInfo.name}}</span>
            </div>
            <div class="top" v-else>
                <span>{{pageInfo.title}}</span>
            </div>
            <div class="tpdata" v-if="pageType==='theme'">
                <span>{{pageInfo.counts.participator}}人参与</span>
                <img src="../../images/hline.png" alt="">
                <span>{{pageInfo.counts.feeds}}条动态</span>
            </div>
          <div class="tpdata" v-else>
            <span>{{pageInfo.followers_count}}人参与</span>
            <img src="../../images/hline.png" alt="">
            <span>{{pageInfo.feeds_count}}条动态</span>
          </div>
            <div class="btnBox" v-if="pageType==='topic'">
                <a href="https://appgallery.huawei.com/app/C102675979"><img src="../../images/blue-btn1.png" alt=""></a>
                <a href="https://appgallery.huawei.com/app/C102675979"><img src="../../images/blue-btn2.png" alt=""></a>
            </div>
        </div>
        <div class="tabs">
            <ul>
                <li :class="feedType === 'hot'?'active-li':''" @click="feedType = 'hot'"> 最热</li>
                <li :class="feedType === 'new'?'active-li':''" @click="feedType = 'new'"> 最新</li>
            </ul>
        </div>
        <div class="mainContent">
            <p><a href="https://appgallery.huawei.com/app/C102675979">展示更多></a></p>
            <div class="feedList">
                <div class="item" @click="goDetailPage(item.share_url)" v-for="(item,i) in contentArr" :key="i"
                     ref='contentItem'>
                    <img :src="item.share_image" alt="" v-if="item.share_image&&item.share_image!=''">
                    <p class="content">{{item.feed_content}}</p>
                    <div class="bottom">
                        <div class="left" v-if="item.user">
                            <img v-if="getUserAvater(item)!==''" :src="getUserAvater(item)" alt="">
                            <span v-if="item.user.name">{{item.user.name}}</span>
                        </div>
                        <div class="right"><img src="../../images/zan.png" alt="">{{item.like_count}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="comment">
            <div class="title">
                <span>推荐圈儿</span>
                <a href="https://appgallery.huawei.com/app/C102675979">查看更多></a>
            </div>
            <div class="circleList">
                <div class="circleItem" v-for="(item,index) in circleList" :key="index">
                    <div class="ccThumb"><img :src="item.thumb" alt=""></div>
                    <p class="ccName">{{item.title}}</p>
                    <p class="ccNumber">{{item.number}}人已加入</p>
                    <a href="https://appgallery.huawei.com/app/C102675979" class="joined" v-if="item.join==1">已加入</a>
                    <a href="https://appgallery.huawei.com/app/C102675979" class="join" v-else>加入</a>
                </div>
            </div>
        </div>
<!--        <div class="shareBtnBox">-->
<!--            <a href="https://appgallery.huawei.com/app/C102675979"><img src="../../images/openapp.png" alt=""></a>-->
<!--            <a href="https://appgallery.huawei.com/app/C102675979" v-if="pageType==='topic'"><img-->
<!--                src="../../images/entercircle.png" alt=""></a>-->
<!--            <a href="https://appgallery.huawei.com/app/C102675979" v-if="pageType==='theme'"><img-->
<!--                src="../../images/entertoic.png"-->
<!--                alt=""></a>-->
<!--        </div>-->
    </div>
</template>

<script>
    import {getTopicFeeds, getTopicInfo, getThemeFeeds, getThemeInfo} from "../../api/sharePage";
    import wechatShare from '@/util/wechatShare.js'
    const feedTypesMap = ['new', 'hot']
    export default {
        name: 'sharePage',
        data() {
            return {
                feedType: 'hot',
                pageInfo: {
                    creator: {},
                    counts: {}
                },
                circleList: [
                    {
                        thumb: 'http://img01.e23.cn/2022/0211/20220211102733585.jpg',
                        title: '文学论坛',
                        number: 389,
                        join: 0
                    }, {
                        thumb: 'http://img01.e23.cn/2021/1231/20211231105703330.jpg',
                        title: '泉城野话',
                        number: 367,
                        join: 1
                    }, {
                        thumb: 'http://img01.e23.cn/2021/1229/20211229070357838.jpg',
                        title: '有料有聊',
                        number: 355,
                        join: 0
                    }, {
                        thumb: 'http://img01.e23.cn/2021/1229/20211229070112892.jpg',
                        title: '运动健身',
                        number: 355,
                        join: 1
                    }, {
                        thumb: 'http://img01.e23.cn/2021/1229/20211229070433172.jpg',
                        title: '文学论坛',
                        number: 389,
                        join: 1
                    }, {
                        thumb: 'http://img01.e23.cn/2021/1231/20211231105703330.jpg',
                        title: '泉城野话',
                        number: 367,
                        join: 1
                    }, {
                        thumb: 'http://img01.e23.cn/2021/1229/20211229070357838.jpg',
                        title: '有料有聊',
                        number: 355,
                        join: 1
                    }, {
                        thumb: 'http://img01.e23.cn/2021/1229/20211229070112892.jpg',
                        title: '运动健身',
                        number: 355,
                        join: 1
                    }
                ],
                contentArr: [],
                array: [],
                activeTab: 0,
                tabArr: ['热门', '最新'],
            }
        },
        watch: {
            feedType(val) {
                if (feedTypesMap.includes(val)) {
                    this.getListData()
                }
            },
        },
        computed: {
            pageType() {
                return this.$route.query.type
                //topic||theme
            },
            pageId() {
                return this.$route.query.id
            },
            isWechat () {
                return this.$store.state.BROWSER.isWechat
            },
        },
        mounted() {
            this.getTopicDetail()
            this.getListData()
        },
        methods: {
            async getTopicDetail() {
                const {pageType, pageId} = this
                let pageData=null;
                if (pageType === 'topic') {//圈子
                    pageData= await getTopicInfo({id: pageId})
                }else {
                    pageData= await getThemeInfo({id: pageId})
                }
                this.$set(this, 'pageInfo', pageData.data)
                const shareUrl =
                    window.location.origin +
                    process.env.BASE_URL.substr(0, process.env.BASE_URL.length - 1) + this.$route.fullPath
                const signUrl =
                    this.$store.state.BROWSER.OS === 'IOS' ? window.initUrl : shareUrl
                document.getElementsByTagName('title')[0].innerText = `舜网`
                const shareTitle=this.pageType==='topic'?this.pageInfo.name:this.pageInfo.title
                const shanreDesc=this.pageType==='topic'?this.pageInfo.desc:this.pageInfo.description
                const imgUrl=this.pageType==='topic'?this.pageInfo.logo.url:this.pageInfo.covers[0].url
                this.isWechat &&
                wechatShare(signUrl, {
                    title: shareTitle,
                    desc: shanreDesc,
                    link: shareUrl,
                    imgUrl: imgUrl,
                })
            },
            getListData() {
                const {pageType, feedType, pageId} = this
                if (pageType === 'topic') {//圈子
                    getTopicFeeds({
                        id: pageId,
                        action: feedType,
                        limit: 10
                    }).then(({data}) => {
                        this.$set(this, 'contentArr', data)
                    }).catch(res => {
                        this.$Message.error('获取列表失败')
                    })
                }else{
                    getThemeFeeds({
                        id: pageId,
                        action: feedType,
                        limit: 10
                    }).then(({data}) => {
                        this.$set(this, 'contentArr', data)
                    }).catch(res => {
                        this.$Message.error('获取列表失败')
                    })
                }

            },
            getUserAvater(user) {
                let avatar = {}
                avatar = user.user && user.user.avatar ? user.user.avatar : ''
                let url = ''
                if (avatar) {
                    url = avatar.url
                }
                return url
            },
            goDetailPage(url) {
                window.location.href = url
            }
        }
    }
</script>

<style scoped lang="less">
    .sharePage {
        padding-bottom: 1.5rem;
    }

    .sharebarimg {
        display: block;
        margin-bottom: 0.2rem;
    }

    .sharebarimg > img {
        width: 100%;
        height: auto;
        display: block;
    }

    .mainContent {
        text-align: center;

        > p {
            text-align: right;
            margin: 0.2rem 0.3rem 0.18rem;

            a {
                font-size: 0.24rem;
                color: #bbbbbb;
                font-weight: 400;
            }
        }

        .feedList {
            padding: 0 0.1rem 0.2rem;
            border-bottom: 1px solid #eee;
            -moz-column-count: 2; /* Firefox */
            -webkit-column-count: 2; /* Safari 和 Chrome */
            column-count: 2;
            box-sizing: border-box;
            -moz-column-gap: 0.1rem;
            -webkit-column-gap: 0.1rem;
            column-gap: 0.1rem;
            display: block;

            .column {
                padding: 0.1rem;
            }

            .item {
                /*width: 100%;*/
                width: 3.60rem;
              color: #000;
              margin-top: 0.35rem;
              /*transition: all 0.5s ease-in-out;*/
              box-sizing: border-box;
              -moz-page-break-inside: avoid;
                -webkit-column-break-inside: avoid;
                -moz-column-break-inside: avoid;
                break-inside: avoid;
                /*position: absolute;*/

                img {
                    width: 100%;
                    height: auto;
                    border-radius: 0.1rem;
                }

                .content {
                    color: #0D1824;
                    font-size: 0.22rem;
                    margin: 0.12rem 0;
                    text-align: left;
                    padding: 0 0.1rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical;
                }

                .bottom {
                    display: flex;
                    justify-content: space-between;
                    align-self: center;
                    padding: 0 0.1rem;

                    .left {
                        display: flex;
                        align-items: center;

                        img {
                            width: 0.36rem;
                            height: 0.36rem;
                            border-radius: 50%;
                            margin-right: 0.07rem;
                        }

                        span {
                            font-size: 0.22rem;
                            color: #50556B;
                        }
                    }

                    .right {
                        display: flex;
                        align-items: center;
                        font-size: 0.22rem;
                        color: #50556B;

                        img {
                            width: 0.24rem;
                            margin-right: 0.1rem;
                        }
                    }
                }
            }
        }
    }


    .topicInfo {
        border-bottom: 0.1rem solid #F8F8F8;
        padding-top: 0.36rem;

        .top {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 0.18rem;

            .thumb {
                width: 0.64rem;
                height: 0.64rem;
                padding: 0.04rem;
                border-radius: 50%;
                overflow: hidden;
                border: 1px solid #E9E9E9;
                margin-right: 0.1rem;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }

            span {
                font-size: 0.4rem;
                color: #0D1824;
                font-weight: bold;
            }
        }

        .tpdata {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.32rem;

            span {
                font-size: 0.22rem;
                color: #50556B;
            }

            img {
                width: 0.04rem;
                margin: 0 0.16rem;
            }
        }

        .btnBox {
            display: flex;
            justify-content: center;
            margin-bottom: 0.36rem;

            a {
                display: block;
                width: 1rem;

                &:first-child {
                    margin-right: 0.17rem;
                }

                img {
                    width: 1.01rem;
                    height: auto;
                }
            }
        }
    }

    .tabs {
        border-bottom: 1px solid #eee;
        margin: 0 0.2rem;

        ul {
            display: flex;
            justify-content: center;
            height: 0.86rem;
            line-height: 0.86rem;

            li {
                position: relative;
                width: 1.5rem;
                text-align: center;
            }

            .active-li:before {
                position: absolute;
                z-index: 1;
                left: 50%;
                bottom: 0px;
                display: inline-block;
                height: 5px;
                width: 30%;
                background-color: #4280F2;
                content: "";
                border-radius: 0.2rem;
                transform: translateX(-50%);
                transition: all 0.5s;
                /*transform: scale3d(0, 1, 1);*/
                /*transform-origin: left;*/
                /*transition: all 0.5s;*/
            }
        }

        /*ul > li:hover > a:before {*/
        /*    transform: scale3d(1, 1, 1);*/
        /*    color: #ed6d00;*/
        /*}*/
    }

    .comment {
        .title {
            padding: 0 0.2rem;
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.45rem;
            margin-top: 0.35rem;
            font-weight: bold;

            a {
                font-size: 0.24rem;
                color: #bbbbbb;
                font-weight: 400;
            }
        }

        .circleList {
            display: flex;
            overflow-x: auto;
            padding-left: 0.3rem;
            padding-bottom: 0.2rem;

            .circleItem {
                width: 1.9rem;
                height: 3.05rem;
                border-radius: 0.1rem;
                border: 1px solid #eee;
                margin-right: 0.2rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;

                .ccThumb {
                    width: 1.15rem;
                    height: 1.15rem;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .ccName {
                    font-size: 0.26rem;
                    color: #333;
                    font-weight: bold;
                    margin-bottom: 0.05rem;
                }

                .ccNumber {
                    font-size: 0.13rem;
                    color: #979797;
                    margin-bottom: 0.1rem;
                }

                .joined {
                    border-radius: 0.2rem;
                    border: 1px solid #eee;
                    font-size: 0.13rem;
                    color: #979797;
                    padding: 0.05rem 0.2rem;
                }

                .join {
                    border-radius: 0.2rem;
                    border: 1px solid #4182E1;
                    font-size: 0.13rem;
                    color: #4182E1;
                    padding: 0.05rem 0.2rem;
                }
            }
        }
    }

    .shareBtnBox {
        position: fixed;
        width: 100%;
        height: 1.3rem;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        box-shadow: 0 0 4px 4px rgba(0, 0, 0, .03);

        a {
            width: 2.38rem;
            height: 0.92rem;

            img {
                width: 100%;
                height: 100%;
            }

            &:first-child {
                margin-right: 1.1rem;
            }
        }
    }
</style>
